import React from 'react';
import { ActivityEntry } from '../../../services/candidateWorkflow.service';
import { stageLabel } from '../../../constants/candidateStage';
import { relativeZeit } from './zeit';

/**
 * Ein Eintrag der Zeitleiste. Übersetzt die technischen Aktionsnamen in
 * lesbare Sätze und macht sichtbar, wer gehandelt hat.
 */

const AKTION_TEXT: Record<string, string> = {
  CANDIDATE_CREATED: 'Kandidat angelegt',
  CANDIDATE_UPDATED: 'Daten geändert',
  CANDIDATE_ASSIGNED: 'Zuständigkeit geändert',
  CANDIDATE_STAGE_CHANGED: 'Status geändert',
  CALL_ATTEMPTED: 'Kontaktversuch',
  CALL_CONNECTED: 'Telefonat',
  EMAIL_RECEIVED: 'E-Mail erhalten',
  EMAIL_SENT: 'E-Mail gesendet',
  NOTE_CREATED: 'Notiz',
  DOCUMENT_UPLOADED: 'Unterlage hochgeladen',
  TASK_CREATED: 'Aufgabe angelegt',
  TASK_COMPLETED: 'Aufgabe erledigt',
  SUBMISSION_CREATED: 'Vorschlag angelegt',
  SUBMISSION_SENT: 'Beim Kunden vorgestellt',
  INTERVIEW_SCHEDULED: 'Interview vereinbart',
  PLACEMENT_CREATED: 'Vermittlung erfasst',
  // Altbestand vor Schritt 2
  stage_changed: 'Status geändert',
  submission_created: 'Vorschlag angelegt',
  candidate_contacted: 'Kontaktiert',
};

const AKTION_FARBE: Record<string, string> = {
  CALL_CONNECTED: '#10B981',
  CALL_ATTEMPTED: '#F59E0B',
  CANDIDATE_STAGE_CHANGED: '#6366F1',
  CANDIDATE_ASSIGNED: '#8B5CF6',
  TASK_COMPLETED: '#10B981',
  PLACEMENT_CREATED: '#059669',
};

function urheber(eintrag: ActivityEntry): string {
  if (eintrag.user_name) return eintrag.user_name;
  if (eintrag.source && eintrag.source !== 'USER') {
    return { SYSTEM: 'System', IMPORT: 'Import', EMAIL_SYNC: 'E-Mail-Abgleich', AUTOMATION: 'Automatik', AI: 'KI' }[eintrag.source] || 'System';
  }
  return 'Unbekannt';
}

function zusatz(eintrag: ActivityEntry): string | null {
  const m = eintrag.metadata || {};
  if (eintrag.action === 'CANDIDATE_STAGE_CHANGED' || eintrag.action === 'stage_changed') {
    const von = stageLabel(m.from_stage, true);
    const nach = stageLabel(m.to_stage, true);
    if (von !== '—' || nach !== '—') return `${von} → ${nach}`;
  }
  if (m.notiz) return String(m.notiz);
  if (m.titel) return String(m.titel);
  return null;
}

export const CandidateActivityItem: React.FC<{ eintrag: ActivityEntry }> = ({ eintrag }) => {
  const text = AKTION_TEXT[eintrag.action] || eintrag.action;
  const farbe = AKTION_FARBE[eintrag.action] || 'var(--text-tertiary)';
  const detail = zusatz(eintrag);

  return (
    <div style={{ display: 'flex', gap: '10px', padding: '9px 0', borderBottom: '1px solid var(--glass-border)' }}>
      <div style={{ width: '8px', paddingTop: '6px', flexShrink: 0 }}>
        <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: farbe }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: '0.86rem', fontWeight: 600, color: 'var(--text-primary)' }}>{text}</div>
        {detail && (
          <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', marginTop: '2px' }}>{detail}</div>
        )}
        <div style={{ fontSize: '0.74rem', color: 'var(--text-tertiary)', marginTop: '3px' }}>
          {relativeZeit(eintrag.occurred_at)} · {urheber(eintrag)}
        </div>
      </div>
    </div>
  );
};

export default CandidateActivityItem;
